export enum EContractStatusType {
  Pending = '1',
  Remit = '2',
  Decline = '3',
  // Additional status for declined = 'V',
}
